export enum ReportActions {
  ReportReset = 'report_reset',
  ReportCopy = 'report_copy',
  ReportExport = 'report_export',
  ReportSave = 'report_save',
  ImplementReset = 'implement_reset',
  ImplementGenerate = 'implement_generate',
}

/** 智能表格操作枚举 */
export enum SmartTableActions {
  Reset = 'smart_table_reset',
  Copy = 'smart_table_copy',
  Export = 'smart_table_export',
  FullScreen = 'smart_table_fullscreen',
  Save = 'smart_table_save',
}

export enum ChatDSFileType {
  Framwork = 'framework',
  Report = 'report',
}

/** 聊天附件内容类型 */
export enum ChatContentType {
  /** 文档报告类型 */
  Document = 'document',
  /** 智能表格类型（对应后端 ai_excel_file） */
  SmartTable = 'ai_excel_file',
  /** 魔法海报类型（对应后端 magic_poster_file） */
  MagicPoster = 'magic_poster_file',
  /** AI Gallery 可发布的 HTML 产物（对应后端 ai_gallery_file） */
  AiGallery = 'ai_gallery_file',
}

/** ChatDSTemplate 支持的模板类型 */
export type TChartTemplate = 'dsReport' | 'aiExcel' | 'magicPoster' | 'skill' | 'splitView';

export enum ModalType {
  Export = 'export',
  Reset = 'reset',
}

export interface IModalConfig  {
  caption: string;
  bodyDesc: string;
  showCancel: boolean;
  onClick?: () => any;
};


export interface ChatDSTemplateActionsListProps {
  handleUpdateDsReport: (update: { show?: boolean; reportId?: string; }) => void;
  startNewConversation: (query: string, args: any[], options: any, params: any) => void;
  conversations?: any[];
  dsReport: {
    document_id?: string;
    version?: string;
    type?: ChatContentType | string;
    answer?: any;
    messageId?: string;
    /** 文件ID，用于智能表格初始化时下载表格数据 */
    file_id?: string;
  };
  sessionId?: string | unknown;
  streamingState?: string;
  /** 是否为只读模式（分享场景下为 true，禁用所有编辑功能） */
  readonly?: boolean;
  /** Copilot 浮动窗口中点击标题栏时提升层级 */
  onFocus?: () => void;
  /** Copilot 浮动窗口中标题栏拖拽 */
  onHeaderMouseDown?: (e: React.MouseEvent) => void;
}

export interface ReportValueState {
  htmlReport: string;
}

export interface ActiveState {
  stepActive: string;
  fileActive: string;
}
